
// "taxAmount"  "totalPriceTax"  totalPrice
function f(options, rows, data, pageData) {
    console.log('options', options, rows, data, pageData);
    // 
    function sumFiled(listData, filed) {
        let res = 0;
        listData.forEach(item => { res = res + Number(item?.[filed] || 0) * 10000; });
        res = res / 10000;
        if (filed == 'quantity') {
            // return res;
            if (options.quantityLittlePoint == undefined || isNaN(options.quantityLittlePoint)) {
                return res;
            }else if (Number(options.quantityLittlePoint) == -1) {
                return res;
            }else if (Number(options.quantityLittlePoint) == 0) {
                return res.toFixed(0);
            }else {
                return res.toFixed(Number(options.quantityLittlePoint));
            }
        } else {
            if (options.littlePoint == undefined || isNaN(options.littlePoint)) {
                return res.toFixed(2);
            }else if (Number(options.littlePoint) == -1) {
                return res;
            }
            else {
                return res.toFixed(Number(options.littlePoint));
            }
        }
    }

    const littleQuantity = sumFiled(pageData, 'quantity'); const totalQuantity = sumFiled(rows, 'quantity');
    const littlePrice = sumFiled(pageData, 'totalPrice'); const totalPrice = sumFiled(rows, 'totalPrice');
    const littleTaxAmount = sumFiled(pageData, 'taxAmount'); const totalTaxAmount = sumFiled(rows, 'taxAmount');
    const littleTotalPriceTax = sumFiled(pageData, 'totalPriceTax'); const totalTotalPriceTax = sumFiled(rows, 'totalPriceTax');
    //���totalTotalPriceTax ����0   totalPriceBigΪ totalTotalPriceTax
    const totalPriceBig = Number(totalTotalPriceTax) > 0 ? hinnn.toUpperCase('7', Number(totalTotalPriceTax)) : hinnn.toUpperCase('7', Number(totalPrice));

    let tr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>`, littleTr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>`, xiaopiaoTr = `<tr style='border:0;height:${options.tableBodyRowHeight || 18}pt;'>`;
    let littleTitleTd = '', titleTd = '', littleQuantityTd = '', totalQuantityTd = '', littlePriceTd = '', totalPriceTd = '', noneTd1 = '', noneTd2 = '';
    let littleTaxAmountTd = '', totalTaxAmountTd = '', littleTotalPriceTaxTd = '', totalTotalPriceTaxTd = '';
    let index1 = 0, index2 = 0,index3 = 0,index4 = 0, columnsLength = options.columns[0].columns.length;
    options.columns[0].columns.forEach((item, index) => {
        if ((item.columnId == 'quantity' && options.tableComputeNumberState) || item.columnId == 'totalPrice'||item.columnId == 'taxAmount'||item.columnId == 'totalPriceTax') {
            let align = item.align || options.textAlign;
            if (index == 0) {
                littleTitleTd = `<td colspan='1' style='text-align: left;' >小计</td>`;
                littleTr += littleTitleTd;
                if (options.computeUpState) {
                    titleTd = `<td colspan='1'  style='text-align: left;'>￥${totalPriceBig}</td>`;
                    tr += titleTd;
                } else {
                    titleTd = `<td colspan='1'  style='text-align: left;'>￥${totalPrice}</td>`;
                    tr += titleTd;
                }
                xiaopiaoTr += `<td colspan='1' style='border:0;border-top: 1px dashed #000;text-align: left;'  >合计</td>`;
                index1 = 0;
            } else if (index1 ==0 && littleTitleTd=='')   {    
                    
                    littleTitleTd = `<td colspan='${index}'  style='text-align: left;' >小计</td>`;
                    littleTr += littleTitleTd;
                    if (options.computeUpState) {
                        titleTd = `<td colspan='${index}'  style='text-align: left;'>合计: ${totalPriceBig}</td>`;
                        tr += titleTd;
                    } else {
                        titleTd = `<td colspan='${index}'  style='text-align: left;'>合计: ￥${totalPrice}</td>`;
                        tr += titleTd;
                    }
                    xiaopiaoTr += `<td colspan='${index}' style='border:0;border-top: 1px dashed #000;text-align: left;'>合计</td>`;
                    
                    if (item.columnId == 'quantity') {
                        littleQuantityTd = `<td colspan='1' style='text-align: ${align};' >${littleQuantity}</td>`;
                        totalQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${totalQuantity}</td>`;
                        littleTr += littleQuantityTd;
                        tr += totalQuantityTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalQuantity}</td>`;
                    } else if(item.columnId == 'totalPrice') {
                        littlePriceTd = `<td colspan='1'  style='text-align: ${align};' >${littlePrice}</td>`;
                        totalPriceTd = `<td colspan='1'  style='text-align: ${align};' >${totalPrice}</td>`;
                        littleTr += littlePriceTd;
                        tr += totalPriceTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalPrice}</td>`;
                    } else if(item.columnId == 'totalPriceTax') {
                        littleTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${littleTotalPriceTax}</td>`;
                        totalTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${totalTotalPriceTax}</td>`;
                        littleTr += littleTotalPriceTaxTd;
                        tr += totalTotalPriceTaxTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTotalPriceTax}</td>`;
                    }else if (item.columnId == 'taxAmount') {
                        littleTaxAmountTd = `<td colspan='1' style='text-align: ${align};' >${littleTaxAmount}</td>`;
                        totalTaxAmountTd = `<td colspan='1'  style='text-align: ${align};' >${totalTaxAmount}</td>`;
                        littleTr += littleTaxAmountTd;
                        tr += totalTaxAmountTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTaxAmount}</td>`;
                    }else {
                        
                    }

                    index1 = index;

                
            } 
             else if (index2 ==0) {
                index2 = index;
                if (index2 - index1 - 1 > 0) {
                    noneTd1 = `<td colspan='${index2 - index1 - 1}' ></td>`;
                    littleTr += noneTd1;
                    tr += noneTd1;
                    xiaopiaoTr += `<td colspan='${index2 - index1 - 1}'  style='border:0;border-top: 1px dashed #000;' ></td>`;
                }
                if (item.columnId == 'quantity') {
                    littleQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${littleQuantity}</td>`;
                    totalQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${totalQuantity}</td>`;
                    littleTr += littleQuantityTd;
                    tr += totalQuantityTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalQuantity}</td>`;
                } else if (item.columnId == 'totalPrice')  {
                    littlePriceTd = `<td colspan='1'  style='text-align: ${align};' >${littlePrice}</td>`;
                    totalPriceTd = `<td colspan='1'  style='text-align: ${align};' >${totalPrice}</td>`;
                    littleTr += littlePriceTd;
                    tr += totalPriceTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalPrice}</td>`;
                } else if (item.columnId == 'totalPriceTax') {
                    littleTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${littleTotalPriceTax}</td>`;
                    totalTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${totalTotalPriceTax}</td>`;
                    littleTr += littleTotalPriceTaxTd;
                    tr += totalTotalPriceTaxTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTotalPriceTax}</td>`;
                }else if (item.columnId == 'taxAmount') {
                    littleTaxAmountTd = `<td colspan='1' style='text-align: ${align};' >${littleTaxAmount}</td>`;
                    totalTaxAmountTd = `<td colspan='1'  style='text-align: ${align};' >${totalTaxAmount}</td>`;
                    littleTr += littleTaxAmountTd;
                    tr += totalTaxAmountTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTaxAmount}</td>`;
                }else {
                    
                }
            }else if (index3 ==0) {
                index3 = index;
                if (index3 - index2 - 1 > 0) {
                    noneTd1 = `<td colspan='${index3 - index2 - 1}' ></td>`;
                    littleTr += noneTd1;
                    tr += noneTd1;
                    xiaopiaoTr += `<td colspan='${index3 - index2 - 1}'  style='border:0;border-top: 1px dashed #000;' ></td>`;
                }
                if (item.columnId == 'quantity') {
                    littleQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${littleQuantity}</td>`;
                    totalQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${totalQuantity}</td>`;
                    littleTr += littleQuantityTd;
                    tr += totalQuantityTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalQuantity}</td>`;
                }else if (item.columnId == 'totalPrice') {
                    littlePriceTd = `<td colspan='1'  style='text-align: ${align};' >${littlePrice}</td>`;
                    totalPriceTd = `<td colspan='1'  style='text-align: ${align};' >${totalPrice}</td>`;
                    littleTr += littlePriceTd;
                    tr += totalPriceTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalPrice}</td>`;
                }else if (item.columnId == 'totalPriceTax') {
                    littleTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${littleTotalPriceTax}</td>`;
                    totalTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${totalTotalPriceTax}</td>`;
                    littleTr += littleTotalPriceTaxTd;
                    tr += totalTotalPriceTaxTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTotalPriceTax}</td>`;
                }else if (item.columnId == 'taxAmount') {
                    littleTaxAmountTd = `<td colspan='1' style='text-align: ${align};' >${littleTaxAmount}</td>`;
                    totalTaxAmountTd = `<td colspan='1'  style='text-align: ${align};' >${totalTaxAmount}</td>`;
                    littleTr += littleTaxAmountTd;
                    tr += totalTaxAmountTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTaxAmount}</td>`;
                }else {
                    
                }
            }else if (index4 ==0) {
                index4 = index;
                if (index4 - index3 - 1 > 0) {
                    
                    noneTd1 = `<td colspan='${index4 - index3 - 1}' ></td>`;
                    littleTr += noneTd1;
                    tr += noneTd1;
                    xiaopiaoTr += `<td colspan='${index4 - index3 - 1}'  style='border:0;border-top: 1px dashed #000;' ></td>`;
                }   
                if (item.columnId == 'quantity') {
                    littleQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${littleQuantity}</td>`;
                    totalQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${totalQuantity}</td>`;
                    littleTr += littleQuantityTd;
                    tr += totalQuantityTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalQuantity}</td>`;
                }else if (item.columnId == 'totalPrice') {
                    littlePriceTd = `<td colspan='1'  style='text-align: ${align};' >${littlePrice}</td>`;
                    totalPriceTd = `<td colspan='1'  style='text-align: ${align};' >${totalPrice}</td>`;
                    littleTr += littlePriceTd;
                    tr += totalPriceTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalPrice}</td>`;
                }else if (item.columnId == 'totalPriceTax') {
                    littleTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${littleTotalPriceTax}</td>`;
                    totalTotalPriceTaxTd = `<td colspan='1'  style='text-align: ${align};' >${totalTotalPriceTax}</td>`;
                    littleTr += littleTotalPriceTaxTd;
                    tr += totalTotalPriceTaxTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTotalPriceTax}</td>`;
                }else if (item.columnId == 'taxAmount') {
                    littleTaxAmountTd = `<td colspan='1' style='text-align: ${align};' >${littleTaxAmount}</td>`;
                    totalTaxAmountTd = `<td colspan='1'  style='text-align: ${align};' >${totalTaxAmount}</td>`;
                    littleTr += littleTaxAmountTd;
                    tr += totalTaxAmountTd;
                    xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalTaxAmount}</td>`;
                }else {
                    
                }
            }
        }
    })
    console.log('index1', index1, index2, columnsLength - index1 - 1, littleTr)
    
    if (index1 == 0 && index2 == 0 ) {
        littleTitleTd = `<td colspan='${columnsLength}' style='text-align: left;' >小计</td>`;
        littleTr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>${littleTitleTd} </tr>`;
        if (options.computeUpState) {
            titleTd = `<td colspan='${columnsLength}'  style='text-align: left;'>合计: ${totalPriceBig}</td>`;
            tr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>${titleTd} </tr>`;
        } else {
            titleTd = `<td colspan='${columnsLength}'  style='text-align: left;'>合计: ${totalPrice}</td>`;
            tr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>${titleTd} </tr>`;
        }
        xiaopiaoTr = `<tr style='border:0;height:${options.tableBodyRowHeight || 18}pt;'><td colspan='${columnsLength}' style='border:0;border-top: 1px dashed #000;text-align: left;'  >合计</td>`;
    } else if (index2 == 0) {
        if (columnsLength - index1 - 1 > 0) {
            tr += `<td colspan='${columnsLength - index1 - 1}' ></td></tr>`;
            littleTr += `<td colspan='${columnsLength - index1 - 1}' ></td></tr>`;
            xiaopiaoTr += `<td colspan='${columnsLength - index1 - 1}'  style='border:0;border-top: 1px dashed #000;'  ></td></tr>`;
        } else {
            tr += `</tr>`;
            littleTr += `</tr>`;
            xiaopiaoTr += `</tr>`;
        }
    } else if (index3 == 0)  {
        if (columnsLength - index2 - 1 > 0) {
            tr += `<td colspan='${columnsLength - index2 - 1}' ></td></tr>`;
            littleTr += `<td colspan='${columnsLength - index2 - 1}' ></td></tr>`;
            xiaopiaoTr += `<td colspan='${columnsLength - index2 - 1}'  style='border:0;border-top: 1px dashed #000;'  ></td></tr>`;
        } else {
            tr += `</tr>`;
            littleTr += `</tr>`;
            xiaopiaoTr += `</tr>`;
        }
    } else if (index4 == 0)  {
        if (columnsLength - index3 - 1 > 0) {
            tr += `<td colspan='${columnsLength - index3 - 1}' ></td></tr>`;
            littleTr += `<td colspan='${columnsLength - index3 - 1}' ></td></tr>`;
            xiaopiaoTr += `<td colspan='${columnsLength - index3 - 1}'  style='border:0;border-top: 1px dashed #000;'  ></td></tr>`;
        }else {
            tr += `</tr>`;
            littleTr += `</tr>`;
            xiaopiaoTr += `</tr>`;
        }
    }else {
        if (columnsLength - index4 - 1 > 0) {
            tr += `<td colspan='${columnsLength - index4 - 1}' ></td></tr>`;
            littleTr += `<td colspan='${columnsLength - index4 - 1}' ></td></tr>`;
            xiaopiaoTr += `<td colspan='${columnsLength - index4 - 1}'  style='border:0;border-top: 1px dashed #000;'  ></td></tr>`;
        }else {
            tr += `</tr>`;
            littleTr += `</tr>`;
            xiaopiaoTr += `</tr>`;
        }
    }

    if (options.tableStyle == 'style2') {
        return xiaopiaoTr;
    }
    if (JSON.stringify(pageData[pageData.length - 1]) == JSON.stringify(rows[rows.length - 1])) {
        if (options.tableCompute1 && options.tableCompute2) {
            return littleTr + tr;
        } else if (options.tableCompute1) {
            return littleTr;
        } else if (options.tableCompute2) {
            return tr;
        } else {
            return ``;
        }
    }
    else {
        if (options.tableCompute1) {
            return littleTr;
        } else {
            return ``;
        }

    }
}
export default f.toString()